import { StrictMap } from '~/shared/utils/strict-map';
import { UiDictionaryType } from '~/modules/dictionaries/enums/UiDictionaryType';
import { ResearchWorkflowStatus } from '~/modules/research/enums/ResearchWorkflowStatus';
import { VideoRecordingProtocolResult } from '~/modules/research/enums/VideoRecordingProtocolResult';

const ResearchWorkflowStatusNames = new StrictMap([
  [ResearchWorkflowStatus.Created, 'Создано'],
  [ResearchWorkflowStatus.InProgress, 'В процессе'],
  [ResearchWorkflowStatus.Breaking, 'Отменяется'],
  [ResearchWorkflowStatus.Broken, 'Отменено'],
  [ResearchWorkflowStatus.Completed, 'Завершено'],
]);

const VideoStatusNames = new StrictMap([
  [VideoRecordingProtocolResult.FullRecording, 'Готово'],
  [VideoRecordingProtocolResult.PartialRecording, 'Готово (неполное)'],
  [VideoRecordingProtocolResult.NoRecording, 'Отсутствует'],
  [VideoRecordingProtocolResult.PendingResult, 'В процессе'],
]);

export const localUIDictionaries = new StrictMap<UiDictionaryType, StrictMap<string, string>>([
  [UiDictionaryType.ResearchWorkflowStatusNames, ResearchWorkflowStatusNames],
  [UiDictionaryType.VideoStatusNames, VideoStatusNames],
]);
